import { isExpectedNoiseError } from "@sum-video/shared/utils/expectedTrpcErrors";
import { withBrowserSentry } from "@/lib/sentry/browserSentry";
import type { CaptureExceptionContext } from "@/lib/sentry/capture";

/**
 * Browser counterpart of lib/sentry/capture: same filtering, but reports
 * through the lazily loaded SDK so client code does not bundle Sentry.
 */
export function captureException(
  error: unknown,
  context?: CaptureExceptionContext,
): void {
  if (isExpectedNoiseError(error)) {
    return;
  }
  withBrowserSentry((sdk) => {
    sdk.captureException(error, {
      tags: context?.tags,
      extra: context?.extra,
      user: context?.user,
    });
  });
}
